export default {
  page: "AllProduct"
};
